export const QUO_CANNOT_TEXT_NOTE = "Quo can't text this number; email the member instead";

const NON_US_CA_NANP_AREA_CODES = new Set([
  '242',
  '246',
  '264',
  '268',
  '284',
  '345',
  '441',
  '473',
  '649',
  '658',
  '664',
  '721',
  '758',
  '767',
  '784',
  '809',
  '829',
  '849',
  '868',
  '869',
  '876',
]);

const E164 = /^\+[1-9]\d{6,14}$/;
const NANP = /^\+1([2-9]\d{2})[2-9]\d{6}$/;

export function isE164(value: string): boolean {
  return E164.test(value);
}

export function quoCanText(phone: string): boolean {
  const match = NANP.exec(phone);
  return match !== null && !NON_US_CA_NANP_AREA_CODES.has(match[1] ?? '');
}
